import { useSearchParams } from "react-router-dom";

import styles from "../../assets/css/remittance.new-rate-compare.module.scss";
import RateCard from "./RateCard";
import arrowRightLine from "../../assets/img/arrow-right-line.svg";
import downArrow from "../../assets/img/downArrow.svg";
import RateCardSkeleton from "./RateCardSkeleton";
import useExchangeRate from "../useExchnagerate";
import { Fragment } from "react";
import { removeDecimal } from "../../libs/utils";

const USD_AMOUNT = 1000;

const NewRateCompare = () => {
  const [searchParams] = useSearchParams();
  //   const loader = true;
  const theme = searchParams.get("theme") || "dark";
  const platform = searchParams.get("platform") || "app";
  const effective_exchange_rate =
    searchParams.get("effective_exchange_rate") || "";
  console.log("effective_exchange_rate", effective_exchange_rate);
  const transfer_fee = searchParams.get("tf");
  const displaytransfer_fee = searchParams.get("dtf");
  const utmSource = searchParams.get("utm_source") || "abound";

  const {
    loader,
    error,
    fxRateData,
    compareRateData,
    dataToRender,
    handleShowMore,
  } = useExchangeRate({ effective_exchange_rate });

  const providerLen = compareRateData?.length;

  const {
    promotional_exchange_rate_applicable,
    promo_fx_rate_data: {
      display_value: formatted_promo_fx_rate = "",
      value: promo_fx_rate,
    } = {},
    // transaction_fee_data = {},
    applicable_transaction_fee_data = {},
  } = fxRateData || {};
  // const transfer_fee_data = {
  //   value: 2.79,
  //   display_value: "$2.79",
  //   currency: "$",
  // };
  const {
    value: transferFeeValue = 0,
    display_value: transferFeeDisplayValue = "",
  } = applicable_transaction_fee_data || {};
  const applicableFee = displaytransfer_fee || transferFeeDisplayValue;
  const effective_exchange_amount = effective_exchange_rate
    ? effective_exchange_rate * (USD_AMOUNT - parseFloat(transfer_fee))
    : promo_fx_rate && fxRateData
    ? (USD_AMOUNT - transferFeeValue) * promo_fx_rate
    : 0;
  // const effective_fee = transfer_fee ?
  const displayExchangeRate = effective_exchange_rate
    ? `₹${effective_exchange_rate}`
    : formatted_promo_fx_rate;
  const promoAmount = (USD_AMOUNT - transferFeeValue) * promo_fx_rate;

  console.log("fxRateData", fxRateData);
  console.log("compareRateData", compareRateData);
  console.log("dataToRender", dataToRender);

  const getGainLoss = (transfer_fee, fxRate) => {
    let amount = "";

    if (effective_exchange_rate) {
      amount = (
        (USD_AMOUNT - transfer_fee) * fxRate -
        effective_exchange_amount
      ).toFixed(2);
    } else if (promotional_exchange_rate_applicable) {
      amount = ((USD_AMOUNT - transfer_fee) * fxRate - promoAmount).toFixed(2);
    }
    return amount;
  };

  const sendMessage = (data = {}) => {
    window.parent.postMessage(
      JSON.stringify(data),
      process.env.REACT_APP_NEOBANK_URL || process.env.REACT_APP_NEOBANK_UAT_URL
    );
  };

  const handleSendMoney = () => {
    if (effective_exchange_rate) {
      sendMessage({ action: "SEND_MONEY" });
      return;
    }
    window.open(
      `${process.env.REACT_APP_TC_URL}/getapp/signup/v2?source=remittance&utm_source=${utmSource}`,
      "_blank"
    );
  };

  const isDark = theme === "dark";

  return (
    <div className={isDark ? styles.dark : styles.light}>
      <div className={styles.mainContainer}>
        {platform === "app" && (
          <div className={styles.heading}>
            The best exchange rates to send money to India
          </div>
        )}
        <div className={styles.mainCardContainer}>
          <div className={styles.fxCardContainer}>
            {loader ? (
              <>
                <RateCardSkeleton isDark={isDark} />
                <RateCardSkeleton isDark={isDark} />
              </>
            ) : error ? (
              <div className={styles.erroMessage}>{error}</div>
            ) : (
              <>
                <RateCard
                  isAbound
                  isPositive
                  exchangeRate={displayExchangeRate}
                  transferFee={applicableFee}
                  recipientGets={`₹${removeDecimal(effective_exchange_amount)}`}
                  isDark={isDark}
                  partnerLogo={
                    isDark
                      ? "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/fx-rate-compare/abound-dark.svg"
                      : "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/fx-rate-compare/abound-light.svg"
                  }
                />
                <div className={styles.sendMoneyContainer}>
                  <div>
                    <span>
                      We aim to always offer the best exchange rate but if you
                      find a better rate elsewhere, do let us know and we'll
                      match it.
                    </span>
                    <span
                      className={styles.boldText}
                    >{` *Feature for Abound Elite users only`}</span>
                  </div>
                  {platform === "web" && (
                    <div
                      className={styles.sendMoneyBox}
                      onClick={handleSendMoney}
                    >
                      <span>Send money</span>
                      <span>
                        <img src={arrowRightLine} alt="arrow" />
                      </span>
                    </div>
                  )}
                </div>
                <div className={styles.otherProvidersContainer}>
                  {dataToRender.map(
                    (
                      {
                        transfer_fee,
                        fx_rate,
                        provider_name,
                        light_logo_url,
                        dark_logo_url,
                      },
                      index
                    ) => {
                      const amount = getGainLoss(transfer_fee, fx_rate);

                      return (
                        <Fragment key={index}>
                          <RateCard
                            isPositive={amount > 0 ? true : false}
                            diff={amount}
                            exchangeRate={
                              fx_rate
                                ? `₹${removeDecimal(fx_rate.toFixed(2))}`
                                : ""
                            }
                            transferFee={`$${removeDecimal(transfer_fee)}`}
                            recipientGets={
                              fx_rate
                                ? `₹${removeDecimal(
                                    (
                                      (USD_AMOUNT - transfer_fee) *
                                      fx_rate
                                    ).toFixed(2)
                                  )}`
                                : ""
                            }
                            providerName={provider_name}
                            partnerLogo={
                              isDark ? dark_logo_url : light_logo_url
                            }
                            isDark={isDark}
                          />
                          {index !== dataToRender.length - 1 && (
                            <div className={styles.divider} />
                          )}
                        </Fragment>
                      );
                    }
                  )}
                  {providerLen > 3 && dataToRender?.length < providerLen && (
                    <>
                      <div className={styles.divider} />
                      <div className={styles.showMore} onClick={handleShowMore}>
                        <div>See more providers</div>
                        <div className={styles.downArrow}>
                          <img src={downArrow} alt="arrow" />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewRateCompare;
